(function () {
  'use strict';
  if (window.SvemobCartMinimum) return;

  const minimum = 125000;
  let total = null;
  let currency = 'SEK';
  let cartURL = '/cart.js';
  let busy = false;
  let message = '';
  let verification = null;
  let mutationVersion = 0;
  const approvedForms = new WeakSet();

  function eligible() {
    return currency === 'SEK' && Number.isFinite(total) && total >= minimum && !busy && !message;
  }

  function draw() {
    const allowed = eligible();
    document.querySelectorAll('svemob-cart-minimum').forEach(function (notice) {
      notice.classList.toggle('sv-cart-minimum--met', allowed);
      const status = notice.querySelector('[data-sv-minimum-status]');
      if (status) {
        let text = message;
        if (!text && busy) text = 'Kontrollerar varukorgen…';
        if (!text && currency !== 'SEK') text = 'Välj svenska kronor för att kontrollera minsta orderbeloppet.';
        if (!text && allowed) text = 'Du har nått minsta orderbeloppet och kan gå till kassan.';
        if (!text && Number.isFinite(total)) {
          const remaining = new Intl.NumberFormat('sv-SE', { style: 'currency', currency: 'SEK', maximumFractionDigits: 2 }).format(Math.max(0, minimum - total) / 100);
          text = 'Lägg till varor för ' + remaining + ' till för att gå till kassan.';
        }
        status.textContent = text || 'Kontrollera varukorgen innan du går till kassan.';
      }
      const retry = notice.querySelector('[data-sv-minimum-retry]');
      if (retry) retry.hidden = !message;
    });
    document.querySelectorAll('[data-svemob-checkout], button[name="checkout"], input[name="checkout"][type="submit"]').forEach(function (button) {
      button.disabled = !allowed;
      button.setAttribute('aria-disabled', String(!allowed));
    });
  }

  function update(cart) {
    if (!cart || !Number.isFinite(cart.total_price) || cart.total_price < 0) {
      message = 'Varukorgen kunde inte kontrolleras. Försök igen innan du går till kassan.';
      busy = false;
      draw();
      return false;
    }
    total = cart.total_price;
    if (cart.currency) currency = cart.currency;
    message = '';
    busy = false;
    draw();
    return eligible();
  }

  function pending() {
    mutationVersion += 1;
    busy = true;
    message = '';
    draw();
  }

  function fail() {
    busy = false;
    message = 'Varukorgen kunde inte kontrolleras. Försök igen innan du går till kassan.';
    draw();
  }

  function sync() {
    if (verification) return verification;
    const version = mutationVersion;
    busy = true;
    message = '';
    draw();
    const controller = new AbortController();
    const timeout = setTimeout(function () { controller.abort(); }, 12000);
    verification = fetch(cartURL, {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' },
      signal: controller.signal
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    }).then(function (cart) {
      if (version !== mutationVersion) return false;
      return update(cart);
    }).catch(function () {
      if (version === mutationVersion) fail();
      return false;
    }).finally(function () {
      clearTimeout(timeout);
      verification = null;
    });
    return verification;
  }

  window.SvemobCartMinimum = { update: update, pending: pending, sync: sync, fail: fail };

  document.addEventListener('change', function (event) {
    if (event.target.matches('input[name="updates[]"]') && event.target.closest('cart-items, cart-notification')) pending();
  }, true);

  if (!customElements.get('svemob-cart-minimum')) {
    customElements.define('svemob-cart-minimum', class extends HTMLElement {
      connectedCallback() {
        total = Number(this.dataset.total);
        currency = this.dataset.currency || 'SEK';
        cartURL = this.dataset.cartJsonUrl || '/cart.js';
        draw();
        // The checkout controls follow this element during a section replacement.
        queueMicrotask(draw);
      }
    });
  }

  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const submitter = event.submitter;
    const isCheckout = (submitter && submitter.name === 'checkout') || /\/checkout(?:[/?]|$)/.test(form.action);
    if (!isCheckout) return;
    if (approvedForms.has(form)) {
      approvedForms.delete(form);
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    sync().then(function (allowed) {
      if (!allowed || !form.isConnected || (submitter && !submitter.isConnected)) return;
      approvedForms.add(form);
      form.requestSubmit(submitter || undefined);
    });
  }, true);

  document.addEventListener('click', function (event) {
    const retry = event.target.closest('[data-sv-minimum-retry]');
    if (retry) { event.preventDefault(); sync(); return; }
    const link = event.target.closest('a[href]');
    if (!link) return;
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || !/\/checkout(?:[/?]|$)/.test(url.pathname)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    sync().then(function (allowed) { if (allowed) window.location.assign(url.href); });
  }, true);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.cartData) update(event.cartData);
    });
  }
})();
